// src/utils/fileUploadUtils.js
export const uploadContentFiles = async (contentId, assets, references) => {
    try {
      // Import services
      const contentService = await import('../services/contentService');
      
      // Track upload results
      const results = {
        assets: [],
        references: []
      };
      
      // Upload assets first if there are any
      if (assets && assets.length > 0) {
        console.log(`Uploading ${assets.length} assets for content ${contentId}`);
        
        // Upload assets one by one to avoid issues
        for (let i = 0; i < assets.length; i++) {
          const asset = assets[i];
          
          // Skip if no file (already uploaded)
          if (!asset.file) continue;
          
          try {
            // Create metadata
            const metadata = {
              type: asset.type || 'image',
              caption: asset.caption || asset.originalname || asset.file.name,
              altText: asset.altText || ''
            };
            
            // Upload the asset
            const uploadedAsset = await contentService.default.uploadContentAsset(
              contentId, 
              asset.file, 
              metadata
            );
            
            results.assets.push(uploadedAsset);
            console.log(`Asset ${i+1}/${assets.length} uploaded successfully`);
          } catch (error) {
            console.error(`Failed to upload asset ${i+1}:`, error);
          }
          
          // Small delay between uploads
          if (i < assets.length - 1) {
            await new Promise(resolve => setTimeout(resolve, 200));
          }
        }
      }
      
      // Upload references if there are any
      if (references && references.length > 0) {
        console.log(`Uploading ${references.length} references for content ${contentId}`);
        
        // Upload references one by one
        for (let i = 0; i < references.length; i++) {
          const reference = references[i];
          
          try {
            // Handle file upload references
            if (reference.file) {
              // Create a FormData
              const formData = new FormData();
              formData.append('file', reference.file);
              formData.append('type', reference.type || 'image');
              formData.append('caption', reference.caption || reference.file.name);
              formData.append('altText', reference.altText || '');
              
              const uploadedReference = await contentService.default.addContentReference(
                contentId, 
                formData
              );
              
              results.references.push(uploadedReference);
            } 
            // Handle URL references
            else if (reference.url) {
              // For URL references, send as JSON
              const urlReference = await contentService.default.addContentReference(
                contentId, 
                {
                  type: reference.type || 'link',
                  url: reference.url,
                  caption: reference.caption || '',
                  altText: reference.altText || ''
                }
              );
              
              results.references.push(urlReference);
            }
            
            console.log(`Reference ${i+1}/${references.length} added successfully`);
          } catch (error) {
            console.error(`Failed to add reference ${i+1}:`, error);
          }
          
          // Small delay between uploads
          if (i < references.length - 1) {
            await new Promise(resolve => setTimeout(resolve, 200));
          }
        }
      }
      
      return results;
    } catch (error) {
      console.error('Error in uploadContentFiles:', error);
      throw error;
    }
  };
  